<template>
  <div id="user-actions">
    <div class="user-actions-container">
      <div class="user-actions-wrapper" v-bind:class="{'side-nav-collapsed' : sideNavCollapsed && !isPluginView }" tabindex="1">

        <div class="user-avatar-wrapper">

          <avatar slot="activator" class="user-avatar" v-bind:type="'member'" v-bind:member="user" v-bind:width="'32px'" v-bind:height="'32px'"
            v-bind:rounded="true" v-bind:showOnlineStatus='true' v-b-toggle.profiledd data-qa-id="avatar-btn">
          </avatar>

          <b-collapse id="profiledd">
            <b-card style="z-index:1000000000;">
              <b-dropdown-item v-on:click="userInfoHandlers.myProfile()">My Profile</b-dropdown-item>
              <b-dropdown-item v-if="!isPluginView" v-on:click="userInfoHandlers.logout()">Logout</b-dropdown-item>
            </b-card>
          </b-collapse>

        </div>

        <div class="avail" v-on:click="userInfoHandlers.availabilityToggler()">
          <img src="static/assets/img/availability-not-available.png" v-if=" user.Availability == 100" />
          <img src="static/assets/img/availability-available.png" v-if=" user.Availability == 10" />
          <img src="static/assets/img/availability-busy.png" v-if=" user.Availability == 20" />
        </div>
        <div class="user-info-wrapper">
          <div class="user-name">{{user.Name}}</div>
          <div class="logout-btn">{{user.Account}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Avatar from './Avatar.vue'
  export default {
    name: 'userInfo',
    props: [
      'user',
      'isPluginView',
      'sideNavCollapsed',
      'userInfoHandlers'
    ],
    components: {
        Avatar
    },
    created() {}
  }

</script>

<style lang='scss' scoped>
  #user-actions {
    position: relative;

    .user-actions-container {
      padding: 5px 0;
      border-bottom: 1px solid $gray-lt;
      width: 100%;
      max-width: 300px;
      height: $Content-nav-height;
      display: block; // overflow-x: hidden;
      // overflow-y: hidden;
      .user-actions-wrapper {
        position: relative;

        .toggle-main-nav {
          font-size: 20px;
          width: 44px;
          height: 44px;
          line-height: 20px;
          padding: 12px;
          position: absolute;
          top: 0;
          left: 0;
          text-align: center;
          cursor: pointer;
        }

        .user-avatar-wrapper {
          position: absolute;
          top: 0px;
          left: 7px;
          padding: 6px 6px 6px 0px;
          cursor: pointer;
        }

        .avail {
          position: absolute;
          right: 0px;
          top: 0px;
          padding: 6px 12px 6px 6px;

          img {
            width: 32px;
            height: 32px;
            cursor: pointer;
          }

          .clock-in-spinner {
            font-size: 25px;
            line-height: 32px;
          }
        }

        .user-info-wrapper {
          margin: 0px 0px 0px 48px;
          padding: 5px 0px;
          cursor: pointer;

          .user-name {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            font-weight: 500;
            line-height: 18px;
          }

          .logout-btn {
            color: #555555;
            font-size: 12px;
            line-height: 14px;
            padding-top: 2px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden; // &:hover {
            // 	color: @Color-blue-lt;
            // 	text-decoration: underline;
            // }
          }
        }

        &.side-nav-collapsed {
          // .user-avatar-wrapper,
          .user-info-wrapper,
          .avail {
            display: none;
          }
        }
        .text-decoration-none:hover {
          a {
            text-decoration: strikethrough;
          }
          text-decoration:none;
        }
      }
    }
  }

  .available {
    color: black; //color: #a25f2f
  }

  .busy {
    color: $blue-dk;
  }

  .nonAvailable {
    color: $gray-lt;
  }

</style>



// WEBPACK FOOTER //
// src/components/Users/UserInfo.vue